

import { defineComponent} from 'vue'

export default defineComponent({
  props: {
    title: {Type: String, required: true},
    description: {Type: String, required: true}
  }
})
